
import { useSearchParams } from "react-router-dom";
import { useState, useMemo } from "react";
import "./AttributeValueFilter.css";

export default function AttributeValueFilter({
    attributes = [],
}) {
    const [searchParams, setSearchParams] = useSearchParams();

    // Store expanded state separately for each attribute
    const [expandedAttributes, setExpandedAttributes] = useState({});

    const selectedValues = useMemo(() => {
        const value = searchParams.get("attributeValues");

        if (!value) {
            return [];
        }

        return value
            .split(",")
            .map(Number)
            .filter(Boolean);
    }, [searchParams]);

    // Toggle only the clicked attribute
    const toggleAttribute = (attributeId) => {
        setExpandedAttributes((prev) => ({
            ...prev,
            [attributeId]: !prev[attributeId],
        }));
    };

    const toggleValue = (valueId) => {
        let values;

        if (selectedValues.includes(valueId)) {
            values = selectedValues.filter(
                (id) => id !== valueId
            );
        } else {
            values = [...selectedValues, valueId];
        }

        const params = new URLSearchParams(searchParams);

        if (values.length > 0) {
            params.set("attributeValues", values.join(","));
        } else {
            params.delete("attributeValues");
        }

        params.delete("page");
        setSearchParams(params);
    };

    if (!attributes.length) {
        return null;
    }

    return (
        <div className="attribute-value-filter">
            <div className="attributes-header">انواع</div>

            {attributes.map((attribute) => {
                // Check whether this specific filter is expanded
                const isExpanded = !!expandedAttributes[attribute.id];

                return (
                    <div
                        key={attribute.id}
                        className="attribute-filter-group"
                    >
                        <div className="attribute-filter-title">
                            {attribute.name}
                        </div>

                        <div className="attribute-filter-values">
                            {(isExpanded
                                ? attribute.values
                                : attribute.values.slice(0, 5)
                            )?.map((value) => {
                                const valueId = Number(value.id);

                                const checked = selectedValues.includes(
                                    valueId
                                );

                                return (
                                    <label
                                        key={value.id}
                                        className="attribute-filter-item"
                                    >
                                        <input
                                            type="checkbox"
                                            checked={checked}
                                            onChange={() =>
                                                toggleValue(valueId)
                                            }
                                        />

                                        <span>{value.name}</span>

                                          {/* {value.productsCount > 0 && (
                                                        <small>
                                                            {value.productsCount}
                                                        </small>
                                                    )} */}


                                    </label>
                                );
                            })}
                        </div>

                        {attribute.values.length > 5 && (
                            <button
                                type="button"
                                className="attribute-toggle-btn"
                                onClick={() =>
                                    toggleAttribute(attribute.id)
                                }
                            >
                                {isExpanded
                                    ? "نمایش کمتر"
                                    : "نمایش بیشتر"}
                            </button>
                        )}
                    </div>
                );
            })}
        </div>
    );
}
